import { AddBoardModel } from "models/AddBoardModel";
import { createContext } from "react";
import { UseFormReturn } from "react-hook-form";

export interface AddBoardFieldValues {
  name: string;
  shortName: string;
  longName: string;
}

export interface AddBoardContextProps {
  confirmUnsaved: boolean;
  setConfirmUnsaved: (value: boolean) => void;
  isDirty: boolean;
  isValid: boolean;
  isSubmitting: boolean;
  form: UseFormReturn<AddBoardFieldValues>;
  getPatch: (values: AddBoardFieldValues) => AddBoardModel;
  handleSave: () => Promise<void>;
  handleClose: (ignoreDirty?: boolean) => void;
  openAddBoard: () => void;
}

export const AddBoardContext = createContext({} as AddBoardContextProps);
